import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { PageLayout } from '@/components/pagelay';
import { getHead, getServerSideProps } from '@/utils/useHead';
import styles from './index.module.scss';
import HTMLFlipBook from 'react-pageflip';
import Head from 'next/head';
//@ts-ignore
import { Map, Marker, NavigationControl, InfoWindow } from 'react-bmap'
import useRequest from '@/utils/useRequest';
import { Pagina } from '@/components/pagination';
import { useDate } from '@/utils/useDate';
import { useTranslations } from 'next-intl';

interface IProps {

}
export { getServerSideProps }

export default ({ navDetail }: any) => {
  const [list, setList] = useState<any>([])
  const [page, setPage] = useState({
    current: 1,
    total: 10,
    pageSize: 10
  })
  const request = useRequest()
  const t = useTranslations();
  const getList = useCallback(async (page?: number) => {
    const { data: list } = await request.get(`/getLogoList`, {
      params: {
        category_id: 3,
        page,
        limit: 999
      }
    })
    setList(list?.data?.list)
  }, [])

  const groupArray = (arr: Array<any>) => {
    const pattern = [5, 6];
    let result = [];
    let index = 0;
    let patternIndex = 0;

    while (index < arr.length) {
      const groupSize = pattern[patternIndex % pattern.length];
      const endIndex = index + groupSize;
      result.push(arr.slice(index, endIndex));
      index = endIndex;
      patternIndex++;
    }
    return result;
  };

  const onPageChange = useCallback((currentPage: number) => {
    getList(currentPage)
    setPage({
      ...page,
      current: currentPage
    })
  }, [page])

  useEffect(() => {
    getList()
  }, [])

  return (
    <PageLayout temp='page_crumb'>
      <div className={styles.container}>
        {getHead(navDetail)}
        <i className={styles.bg1}></i>
        <div className='minHidden'>
          <div>
            {
              list.length &&
              groupArray(list).map((item: any) => (
                <div className={styles.row}>
                  {
                    item.map((child: any) => (
                      <a href={child.url ? child.url : `javascript:;`} target={child.url ? '_blank' : '_self'}>
                        <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src={child.image} alt="" />
                      </a>
                    ))
                  }
                </div>
              ))
            }
          </div>
        </div>
        <div className='minShow' style={{ display: 'none' }}>
          <div>
            {
              list.map((item: any) => (
                <div className={styles.row}>
                  <a href={item.url ? item.url : `javascript:;`} target={item.url ? '_blank' : '_self'}>
                    <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src={item.image} alt="" />
                  </a>
                </div>
              ))
            }
          </div>
        </div>
        <style jsx global>
          {
            `
              
            `
          }
        </style>
      </div>
    </PageLayout>

  );
};


